module.exports = __webpack_public_path__ + "static/media/img-02.f22307ec.png";